import OrganizationError from "@/lib/organization/error/OrganizationError";

export default class NotInWhitelabelError extends OrganizationError
{

}
